import { Permissions } from 'components/account/AccountView/users/types';
import { RBAC_ROLES } from 'components/admin/utils/feature-flags';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import useAuth from 'hooks/useAuth';

export default function useHasPermission(
  permission: Permissions | Permissions[],
  requireAll = true,
): boolean {
  const { userHasPermission, isHistorySession } = useAuth();
  const { hasLabsFlag, hasInitialized } = usePSLabs();

  if (!hasInitialized) return false;
  if (!isHistorySession && !hasLabsFlag(RBAC_ROLES)) return true;

  if (Array.isArray(permission)) {
    if (permission.length === 0) return false;

    return requireAll
      ? permission.every(userHasPermission)
      : permission.some(userHasPermission);
  }

  return userHasPermission(permission);
}
